// import "./App.css";
import React, { Component } from "react";
import TocIcon from '@material-ui/icons/Toc';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import "./index.css";
import Home from "./Home";
import About from "./About";
// import Service from "./Service";
import Skill from "./Skill";
import Project from "./Project";
import Contact from "./Contact";
import SideMenu from "./SideMenu";
import Footer from "./Footer";
import { NavLink, Switch, Route, Redirect , useLocation } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
// import Navbar from './Navbar';


class App extends Component {
  
  render() {


    // let p = useLocation();
    // console.log(p.pathname);
 
  return (
    <>
      <div className="scroll-up-btn">
        {/* <i className="fas fa-angle-up"></i> */}
        <i><ArrowUpwardIcon/></i>
      </div>
      <nav className={"navbar sticky"}>
        <div className="max-width">
          <div className="logo">
            <NavLink to="/about">
              Sakshat<span>Mali</span>
            </NavLink>
          </div>
          <ul className="menu">
            <li>
              <a><NavLink to="/home" className="menu-btn" >
                Home
              </NavLink></a>
            </li>
            <li>
              <a><NavLink to="/about" className="menu-btn">
                About
              </NavLink></a>
            </li>
            {/* <li>
              <NavLink to="/service" className="menu-btn">
                Services
              </NavLink>
            </li> */}
            <li>
              <a><NavLink to="/skill" className="menu-btn">
                Skills
              </NavLink></a>
            </li>
            <li>
              <a><NavLink to="/project" className="menu-btn">
                Projects
              </NavLink></a>
            </li>
            <li>
              <a><NavLink to="/contact" className="menu-btn">
                Contact
              </NavLink></a>
            </li>
          </ul>
          <div className="menu-btn">
            {/* <i className="fas fa-bars"></i> */}
            <i><NavLink to="/side">
            <TocIcon style={{fontSize:"40px"}}/>
              </NavLink></i>
          </div>
        </div>
      </nav>

      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        {/* <Route exact path="/service" component={Service} /> */}
        <Route exact path="/skill" component={Skill} />
        <Route exact path="/project" component={Project} />
        <Route exact path="/contact" component={Contact} />
        <Route exact path="/side" component={SideMenu} />
        <Redirect to="/" />
      </Switch>

      <Footer/>
    </>
  );
};
};

export default App;